import * as unitHandoverTypes from 'constants/enums/unitHandoverTypes'

export default {
  [unitHandoverTypes.STANDARD]: 'Standardní',
  [unitHandoverTypes.NON_STANDARD]: 'Nestandardní',
  [unitHandoverTypes.OTHER]: 'Jiné',
}
